import { ReactNode, useContext } from 'react'

import { RoundTableContext } from '../../context/RoundTableContext'
import { RoundTableText } from '../roundTableText/RoundTableText'

import styles from './RoundTableLabel.module.scss'

export const RoundTableLabel = ({ children }: { children?: ReactNode }) => {
  const { ready } = useContext(RoundTableContext)
  if (!ready) return null
  return (
    <span className={styles.badge}>
      <i className="kbase kbase-lvl-session" aria-hidden />
      <RoundTableText name="label" />
      {children}
    </span>
  )
}
